import React from "react";
import Invoice from "./InvoiceList/Invoice";

const InvoiceReport = () => {
    return <Invoice type="report" title="Invoice summary" />;
};

export default InvoiceReport;
